// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import {
  LoadingOutlined,
  HomeOutlined,
  NotificationFilled,
} from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenClusterColVer from "./Common/Graph/ZenClusterColVer";
import ZenClusterColHor from "./Common/Graph/ZenClusterColHor";
import ZenPieBar from "./Common/Graph/ZenPieBar";
import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
import ZenPareto from "./Common/Graph/ZenPareto";
import ZenVerStackBar from "./Common/Graph/ZenVerStackBar";
import ZenHorStackBar from "./Common/Graph/ZenHorStackBar";
import ZenVerCandleStick from "./Common/Graph/ZenVerCandleStick";
import ZenHorCandleStick from "./Common/Graph/ZenHorCandleStick";

import ZenGoldenTunnel from "./Common/Graph/ZenGoldenTunnel";
import ZenGanttChart from "./Common/Graph/ZenGanttChart";
import ZenStackedNePo from "./Common/Graph/ZenStackedNePo";
import ZenDonut from "./Common/Graph/ZenDonut";
import ZenGauge from "./Common/Graph/ZenGauge";
import ZenGaugeOmega from "./Common/Graph/ZenGaugeOmega";


import ZenSpectrum from "./Common/Graph/ZenSpectrum";
import ZenRadar from "./Common/Graph/ZenRadar";
import Angela1C from "./Common/Angela/Angela1C";
import Angela1R from "./Common/Angela/Angela1R";
import AngelaIcon1R from "./Common/Angela/AngelaIcon1R";
import AngelaIconMultiR2C from "./Common/Angela/AngelaIconMultiR2C";
import AngelaIconMultiR1C from "./Common/Angela/AngelaIconMultiR1C";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";
import ZenGaugeMultiColor from "./Common/Graph/ZenGaugeMultiColor";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ZenChartArsenal extends React.Component {
  state = {
    mainData: null,
    SnippetLineZenGaugeSingle: null,
    SnippetLineZenGaugeAPQ: null,
    SnippetLineZenGaugeAPQ_A: null,
    SnippetLineZenGaugeAPQ_P: null,
    SnippetLineZenGaugeAPQ_Q: null,
    SnippetLineZenDonutTimeDistribution: null,
    SnippetLineZenVerBarChartHourlyOEE: null,
    ZenVerBarChart: null,
    ZenVerBarChartMultiColorGreen: null,
    ZenVerBarChartMultiColorRed: null,
    ZenHorBarChart25: null,
    ZenHorBarChart33: null,
    ZenHorBarChart40: null,
    ZenWaterfallChart: null,
    ZenClusterColVer: null,
    ZenClusterColHor: null,
    ZenVerStackBar: null,
    ZenHorStackBar: null,
    ZenVerCandleStick: null,
    ZenHorCandleStick: null,
    ZenGanttChart: null,
    ZenPieBar: null,
    ZenStackedNePo: null,
    ZenDonut: null,
    ZenPareto: null,
    ZenRadar: null,
    AngelaIconMultiR2C: null,
    AngelaIconMultiR1C: null,
    Angela1C_SingleRow: null,
    Angela1C_MultiRow: null,
    Angela1R_SingleCol: null,
    AngelaIcon1R_SingleCol: null,
    AngelaIcon1R_SingleColDoubleLine: null,

    ZenVerBarAndTrend: null,
    ZenGoldenTunnel: null,
    ZenSpectrum: null,

    GtManpower: null,
    GtLpg: null,
    GtMseb: null,
    ZenGauge: null,
    ZenGaugeOmega:null,
    GtHorCostContributor: null,
    GaugeVBarB: null,
    GaugeVBarG: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    console.log("change--***");
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Zen Chart Arsenal");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "ZenChartArsenal",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};

        respData["SnippetLineZenGaugeSingle"] =
          resp["data"]["SnippetLineZenGaugeSingle"];
        respData["SnippetLineZenGaugeOEE"] =
          resp["data"]["SnippetLineZenGaugeOEE"];
        respData["SnippetLineZenGaugeAPQ"] =
          resp["data"]["SnippetLineZenGaugeAPQ"];
        respData["SnippetLineZenGaugeAPQ_A"] =
          resp["data"]["SnippetLineZenGaugeAPQ_A"];
        respData["SnippetLineZenGaugeAPQ_P"] =
          resp["data"]["SnippetLineZenGaugeAPQ_P"];
        respData["SnippetLineZenGaugeAPQ_Q"] =
          resp["data"]["SnippetLineZenGaugeAPQ_Q"];
        respData["SnippetLineZenDonutTimeDistribution"] =
          resp["data"]["SnippetLineZenDonutTimeDistribution"];
        respData["SnippetLineZenVerBarChartHourlyOEE"] =
          resp["data"]["SnippetLineZenVerBarChartHourlyOEE"];
        respData["ZenVerBarChart25"] = resp["data"]["ZenVerBarChart25"];
        respData["ZenVerBarChart33"] = resp["data"]["ZenVerBarChart33"];
        respData["ZenVerBarChart40"] = resp["data"]["ZenVerBarChart40"];


        respData["ZenVerBarChartMultiColorGreen"] =
          resp["data"]["ZenVerBarChartMultiColorGreen"];
          respData["ZenVerBarChartMultiColorRed"] =
          resp["data"]["ZenVerBarChartMultiColorRed"];


          
        respData["ZenHorBarChart"] = resp["data"]["ZenHorBarChart"];
        respData["ZenPareto"] = resp["data"]["ZenPareto"];
        respData["ZenDonut"] = resp["data"]["ZenDonut"];
        respData["ZenGauge"] = resp["data"]["ZenGauge"];
        respData["ZenGaugeOmega"] = resp["data"]["ZenGaugeOmega"];
        respData["GaugeVBarB"] = resp["data"]["GaugeVBarB"];
        respData["GaugeVBarG"] = resp["data"]["GaugeVBarG"];
        // respData["Angela"] = resp["data"]["Angela"];
        respData["ZenSpectrum"] = resp["data"]["ZenSpectrum"];
        respData["ZenRadar"] = resp["data"]["ZenRadar"];

        respData["ZenPieBar"] = resp["data"]["ZenPieBar"];

        respData["ZenVerStackBar"] = resp["data"]["ZenVerStackBar"];
        respData["ZenHorStackBar"] = resp["data"]["ZenHorStackBar"];

        respData["ZenVerCandleStick"] = resp["data"]["ZenVerCandleStick"];
        respData["ZenHorCandleStick"] = resp["data"]["ZenHorCandleStick"];
        respData["ZenWaterfallChart"] = resp["data"]["ZenWaterfallChart"];
        respData["ZenClusterColVer"] = resp["data"]["ZenClusterColVer"];
        respData["ZenClusterColHor"] = resp["data"]["ZenClusterColHor"];

        respData["ZenGanttChart"] = resp["data"]["ZenGanttChart"];
        respData["ZenStackedNePo"] = resp["data"]["ZenStackedNePo"];
        respData["ZenGoldenTunnel"] = resp["data"]["ZenGoldenTunnel"];
        respData["AngelaIconMultiR2C"] = resp["data"]["AngelaIconMultiR2C"];

        respData["AngelaIconMultiR1C"] = resp["data"]["AngelaIconMultiR1C"];

        respData["Angela1C_SingleRow"] = resp["data"]["Angela1C_SingleRow"];
        respData["Angela1C_MultiRow"] = resp["data"]["Angela1C_MultiRow"];
        respData["Angela1R_SingleCol"] = resp["data"]["Angela1R_SingleCol"];
        respData["AngelaIcon1R_SingleCol"] =
          resp["data"]["AngelaIcon1R_SingleCol"];

        respData["AngelaIcon1R_SingleColDoubleLine"] =
          resp["data"]["AngelaIcon1R_SingleColDoubleLine"];
        respData["ZenVerBarAndTrend"] = resp["data"]["ZenVerBarAndTrend"];
        // respData["GtHorCostContributor"] = resp["data"]["GtHorCostContributor"];

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
        ? "all"
        : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>
                {this.state.mainData ? (
                  <div
                    style={{
                      margin: "10px",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        color: "#9b59b6",
                        fontSize: 36,
                        fontWeight: 800,
                        textAlign: "center",
                        margin: "0px 0px 0px 0px",
                      }}
                    >
                      ZEN CHART ARSENAL
                    </div>

                    {/* TEMPLATE ROW WITH COLUMNS     */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "20%" }}></Col>

                      <Col style={{ width: "20%" }}></Col>
                      <Col style={{ width: "20%" }}></Col>
                      <Col style={{ width: "40%" }}></Col>
                    </Row>

                    {/* ____________________________________START _____________________________________________*/}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          AngelaIconMultiR2C
                        </div>

                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A008
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "200px",
                          }}
                        >
                          <AngelaIconMultiR2C
                            divId={"AngelaIconMultiR2C"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                              dn: "AngelaIconMultiR2C"
                            }}
                            // data={this.state.AngelaIconMultiR2C.data}
                            // config={this.state.AngelaIconMultiR2C.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          AngelaIconMultiR1C
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A007
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "140px",
                          }}
                        >
                          <AngelaIconMultiR1C
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                              dn: "AngelaIconMultiR1C"
                            }}
                            divId={"AngelaIconMultiR1C"}
                            // data={this.state.AngelaIconMultiR1C.data}
                            // config={this.state.AngelaIconMultiR1C.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Angela1C_SingleRow
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A003
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela1C_SingleRow"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",

                            }}
                            // data={this.state.Angela1C_SingleRow.data}
                            // config={this.state.Angela1C_SingleRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontSize: 10,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Angela1C_MultiRowOneLineHeader
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",

                          }}
                        >
                          A011
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #1677FF",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela1C_MultiRowOneLineHeader"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                              dn: "Angela1C_MultiRowOneLineHeader"
                              
                              
                            }}
                            // data={this.state.Angela1C_MultiRow.data}
                            // config={this.state.Angela1C_MultiRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                              fontSize: 10,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Angela1C_MultiRowTwoLineHeader
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A012
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #1677FF",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela1C_MultiRowTwoLineHeader"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                              dn: "Angela1C_MultiRowTwoLineHeader"
                              
                            }}
                            // data={this.state.Angela1C_MultiRow.data}
                            // config={this.state.Angela1C_MultiRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ background: "#000000", marginTop: "60px" }}>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Angela1R_SingleCol
                        </div>

                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A004
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "180px",
                          }}
                        >
                          <Angela1R
                            divId={"Angela1R_SingleCol"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.Angela1R_SingleCol.data}
                            // config={this.state.Angela1R_SingleCol.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        {" "}
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          AngelaIcon1R_SingleCol
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A005
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "150px",
                          }}
                        >
                          <AngelaIcon1R
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            divId={"AngelaIcon1R_SingleCol"}
                            // data={this.state.AngelaIcon1R_SingleCol.data}
                            // config={this.state.AngelaIcon1R_SingleCol.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        {" "}
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          AngelaIcon1R_SingleColDoubleLine
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          A006
                        </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "185px",
                          }}
                        >
                          <AngelaIcon1R
                            divId={"AngelaIcon1R_SingleColDoubleLine"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={
                            //   this.state.AngelaIcon1R_SingleColDoubleLine.data
                            // }
                            // config={
                            //   this.state.AngelaIcon1R_SingleColDoubleLine.config
                            // }
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        {" "}
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          SPARE
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "15%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZEN GAUGE
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C015
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "95%",
                          }}
                        >
                          <ZenGauge
                            divId={"ZenGauge"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenGauge.data}
                            // config={this.state.ZenGauge.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />

                        </div>


                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZEN GAUGE MULTICOLOR
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C030
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "95%",
                          }}
                        >
                          <ZenGaugeMultiColor
                            divId={"ZenGaugeMultiColor"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenGauge.data}
                            // config={this.state.ZenGauge.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />

                        </div>





                        
                      </Col>

                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        ></div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        ></div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "93%",
                          }}
                        >
                          <Row>
                            <ZenGauge
                              divId={"SnippetLineZenGaugeOEE"}
                              api={"/chart/charttemplate"}
                              urlData={{
                                lid: "all",
                                mnt: "all",
                                typ: "MainGraph",
                                subTyp: this.state.selectedTab,
                                chartGroup: "ZenChartArsenal",
                              }}
                              // data={this.state.SnippetLineZenGaugeOEE.data}
                              // config={this.state.SnippetLineZenGaugeOEE.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </Row>

                          <Row>
                            <Col style={{ width: "30%" }}>
                              <ZenGauge
                                divId={"SnippetLineZenGaugeAPQ_1"}
                                api={"/chart/charttemplate"}
                                urlData={{
                                  lid: "all",
                                  mnt: "all",
                                  typ: "MainGraph",
                                  subTyp: this.state.selectedTab,
                                  chartGroup: "ZenChartArsenal",
                                }}
                                // data={this.state.SnippetLineZenGaugeAPQ.data}
                                // config={
                                //   this.state.SnippetLineZenGaugeAPQ.config
                                // }
                                onChange={(data) => this.changeBasicGraph(data)}
                              />
                            </Col>
                            <Col style={{ width: "30%" }}>
                              <ZenGauge
                                divId={"SnippetLineZenGaugeAPQ_2"}
                                api={"/chart/charttemplate"}
                                urlData={{
                                  lid: "all",
                                  mnt: "all",
                                  typ: "MainGraph",
                                  subTyp: this.state.selectedTab,
                                  chartGroup: "ZenChartArsenal",
                                }}
                                // data={this.state.SnippetLineZenGaugeAPQ.data}
                                // config={
                                //   this.state.SnippetLineZenGaugeAPQ.config
                                // }
                                onChange={(data) => this.changeBasicGraph(data)}
                              />
                            </Col>
                            <Col style={{ width: "30%" }}>
                              <ZenGauge
                                divId={"SnippetLineZenGaugeAPQ_3"}
                                api={"/chart/charttemplate"}
                                urlData={{
                                  lid: "all",
                                  mnt: "all",
                                  typ: "MainGraph",
                                  subTyp: this.state.selectedTab,
                                  chartGroup: "ZenChartArsenal",
                                }}
                                // data={this.state.SnippetLineZenGaugeAPQ.data}
                                // config={
                                //   this.state.SnippetLineZenGaugeAPQ.config
                                // }
                                onChange={(data) => this.changeBasicGraph(data)}
                              />
                            </Col>
                          </Row>
                        </div>




                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZEN GAUGE OMEGA
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C034
                        </div>


                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "95%",
                          }}
                        >
                          <ZenGaugeOmega
                            divId={"ZenGaugeOmega"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenGauge.data}
                            // config={this.state.ZenGauge.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />

                        </div>





                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          CHARTXXX
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C000
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",
                            width: "60%",
                            height: "200px",
                          }}
                        >
                          <ZenGauge
                            divId={"GaugeVBarG"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.GaugeVBarG.data}
                            // config={this.state.GaugeVBarG.config}
                          />

                          {/* <ZenVerBarChart
                            divId={"GaugeVBarB"}
                            data={this.state.GaugeVBarB.data}
                            config={this.state.GaugeVBarB.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          /> */}
                        </div>
                      </Col>
                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenDonut
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C013
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 10px 10px 10px",
                            width: "95%",
                          }}
                        >
                          <ZenDonut
                            divId={"ZenDonut"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={
                            //   this.state.SnippetLineZenDonutTimeDistribution
                            //     .data
                            // }
                            // config={
                            //   this.state.SnippetLineZenDonutTimeDistribution
                            //     .config
                            // }
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "20%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenRadar
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C022
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "100%",
                          }}
                        >
                          <ZenRadar
                            divId={"ZenRadar"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenRadar.data}
                            // config={this.state.ZenRadar.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>


{/* New Row for verticalBar Chart */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChart 25%
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C025
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart25"}
                            // data={this.state.ZenVerBarChart25.data}
                            // config={this.state.ZenVerBarChart25.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={"/chart/charttemplate"}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "33%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChart 33%
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C033
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart33"}
                            // data={this.state.ZenVerBarChart33.data}
                            // config={this.state.ZenVerBarChart33.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={"/chart/charttemplate"}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                          />
                        </div>
                      </Col>
          
                      <Col style={{ width: "40%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChart 40%
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C040
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart40"}
                            // data={this.state.ZenVerBarChart40.data}
                            // config={this.state.ZenVerBarChart40.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={"/chart/charttemplate"}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                          />
                        </div>
                      </Col>







                    </Row>












                    {/* SECOND ROW */}
                    <Row style={{ background: "#000000" }}>
                      {/* <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChart
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C025
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart"}
                            // data={this.state.ZenVerBarChart.data}
                            // config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={"/chart/charttemplate"}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                          />
                        </div>
                      </Col> */}

                      <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChartMultiColorGreen
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C031
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChartMultiColorGreen"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerBarChartMultiColorGreen.data}
                            // config={this.state.ZenVerBarChartMultiColorGreen.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChartMultiColorRed
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C032
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChartMultiColorRed"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerBarChartMultiColorRed.data}
                            // config={this.state.ZenVerBarChartMultiColorRed.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenHorBarChart
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C017
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "95%",
                          }}
                        >
                          <ZenHorBarChart
                            divId={"ZenHorBarChart"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenHorBarChart.data}
                            // config={this.state.ZenHorBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/* THIRD ROW */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenWaterfallChart
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C029
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "95%",
                          }}
                        >
                          <ZenWaterfallChart
                            divId={"ZenWaterfallChart"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenWaterfallChart.data}
                            // config={this.state.ZenWaterfallChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenPareto
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C020
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "95%",
                          }}
                        >
                          <ZenPareto
                            divId={"ZenPareto"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenPareto.data}
                            // config={this.state.ZenPareto.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/* FOURTH ROW */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenClusterColVer
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C012
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenClusterColVer
                            divId={"ZenClusterColVer"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // respData = {this.state.ZenVerBarChart}
                            // data={this.state.ZenClusterColVer.data}
                            // config={this.state.ZenClusterColVer.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenClusterColHor
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C011
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenClusterColHor
                            divId={"ZenClusterColHor"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // respData = {this.state.ZenVerBarChart}
                            // data={this.state.ZenClusterColHor.data}
                            // config={this.state.ZenClusterColHor.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>
                    {/* FIFTH ROW */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerStackBar
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C028
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerStackBar
                            divId={"ZenVerStackBar"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerStackBar.data}
                            // config={this.state.ZenVerStackBar.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenHorStackBar
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C019
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenHorStackBar
                            divId={"ZenHorStackBar"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenHorStackBar.data}
                            // config={this.state.ZenHorStackBar.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerCandleStick
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C027
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerCandleStick
                            divId={"ZenVerCandleStick"}
                            api={'/chart/charttemplate'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerCandleStick.data}
                            // config={this.state.ZenVerCandleStick.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenHorCandleStick
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C018
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenHorCandleStick
                            divId={"ZenHorCandleStick"}
                            api={'/chart/charttemplate'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenHorCandleStick.data}
                            // config={this.state.ZenHorCandleStick.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ background: "#000000" }}>
                      {/* <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenPieBar
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C021
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "95%",
                          }}
                        >
                          <ZenPieBar
                            divId={"ZenPieBar"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenPieBar.data}
                            // config={this.state.ZenPieBar.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col> */}

                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenStackedNePo
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C024
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "95%",
                          }}
                        >
                          <ZenStackedNePo
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            divId={"ZenStackedNePo"}
                            // data={this.state.ZenStackedNePo.data}
                            // config={this.state.ZenStackedNePo.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

    <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenVerBarChartMultiColorGreen
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C031
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChartMultiColorGreen"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerBarChartMultiColorGreen.data}
                            // config={this.state.ZenVerBarChartMultiColorGreen.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>






                      <Col style={{ width: "25%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Gantt
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C031
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenGanttChart
                            divId={"ZenGanttChart"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenVerBarChartMultiColorGreen.data}
                            // config={this.state.ZenVerBarChartMultiColorGreen.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>






                    </Row>

                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>
                        <div
                          style={{
                            color: "#bdc3c7",
                            paddingTop: "40px",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          ZenGoldenTunnel
                        </div>
                        <div
                          style={{
                            color: "#e74c3c",
                            fontSize: 20,
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          C016
                        </div>

                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "1000px",
                          }}
                        >
                          <ZenGoldenTunnel
                            divId={"ZenGoldenTunnel"}
                            api={"/chart/charttemplate"}
                            urlData={{
                              lid: "all",
                              mnt: "all",
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "ZenChartArsenal",
                            }}
                            // data={this.state.ZenGoldenTunnel.data}
                            // config={this.state.ZenGoldenTunnel.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>

                      <Col style={{ width: "50%" }}></Col>
                    </Row>

                    <Row style={{ background: "#000000" }}>
                      <div
                        style={{
                          color: "#bdc3c7",
                          paddingTop: "40px",
                          fontWeight: 500,
                          textAlign: "center",
                          margin: "100px 0px 10px 10px",
                        }}
                      >
                        ZenSpectrum
                      </div>
                      <div
                        style={{
                          color: "#e74c3c",
                          fontSize: 20,
                          fontWeight: 500,
                          textAlign: "center",
                          margin: "100px 0px 10px 10px",
                        }}
                      >
                        C023
                      </div>

                      <div
                        style={{
                          borderRadius: "10px",
                          background: "#191C24",
                          border: "1px solid #3c3e4f",
                          margin: "10px 0px 100px 10px",

                          width: "1000px",
                        }}
                      >
                        <ZenSpectrum
                          divId={"ZenSpectrum"}
                          api={"/chart/charttemplate"}
                          urlData={{
                            lid: "all",
                            mnt: "all",
                            typ: "MainGraph",
                            subTyp: this.state.selectedTab,
                            chartGroup: "ZenChartArsenal",
                          }}
                          // data={this.state.ZenSpectrum.data}
                          // config={this.state.ZenSpectrum.config}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      </div>
                    </Row>

                    {/* <Row style={{ background: "#000000" }}>
                      

                      <Col style={{ width: "35%" }}>
                      <div
                        style={{
                          color: "#bdc3c7",
                          paddingTop: "40px",
                          fontWeight: 500,
                          textAlign: "center",
                          margin: "0px 0px 10px 10px",
                        }}
                      >
                        ZenVerBarAndTrend
                      </div>
                      <div
                        style={{
                          color: "#e74c3c",
                          fontSize: 20,
                          fontWeight: 500,
                          textAlign: "center",
                          margin: "0px 0px 10px 10px",
                        }}
                      >
                        C005
                      </div>
                        <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarAndTrend"}
                            // respData = {this.state.ZenVerBarChart}
                            data={this.state.ZenVerBarAndTrend.data}
                            config={this.state.ZenVerBarAndTrend.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>
                      </Col>
                    </Row> */}
                  </div>
                ) : null}

                <Col span={8} style={{}}></Col>

                <Col span={12}></Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>

          <Row style={{ background: "#000000" }}></Row>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ZenChartArsenal;
